const WORDS = ["We bring the shop to you", "Diagnostics", "Brakes & suspension", "Oil changes", "Maintenance & repairs", "Engine & transmission swaps"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-race whitespace-nowrap px-8 text-6xl sm:text-8xl ${i % 2 ? "text-outline" : "text-chrome"}`}>{w}</span>
        <svg viewBox="0 0 24 24" className="h-8 w-8 shrink-0 sm:h-10 sm:w-10"><path d="M12 0l3 9 9 3-9 3-3 9-3-9-9-3 9-3z" fill="#ff2bd6" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="marquee-section" aria-label="Services ticker" className="relative overflow-hidden border-y border-white/10 bg-[#0a0a10] py-10">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
